const ITEMS = [
    "Location de matériel",
    "Véhicules sans chauffeur",
    "Travaux BTP",
    "Électricité",
    "Plomberie",
    "Carrelage",
    "Rénovation",
];

const Row = () => (
    <div className="flex shrink-0 items-center">
        {ITEMS.map((item) => (
            <span key={item} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-display text-2xl font-extrabold uppercase tracking-tight text-white/85 sm:text-3xl">
                    {item}
                </span>
                <span className="h-2.5 w-2.5 rotate-45 bg-signal" aria-hidden="true" />
            </span>
        ))}
    </div>
);

export const Marquee = () => (
    <div
        data-testid="editorial-marquee"
        className="overflow-hidden border-y border-white/10 bg-coal py-7"
        aria-hidden="true"
    >
        <div className="flex w-max animate-marquee">
            <Row />
            <Row />
        </div>
    </div>
);
